//
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import '@/assets/global.scss';

import vuetify from './plugins/vuetify';
import AxiosConfig from './plugins/axios/axios-config';
import Utils from './plugins/utils';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as evt from './extendsVueType';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as UtilsTypes from './plugins/utils.types';
import { EventBus } from './utils/event-bus';
import { Analytics } from './plugins/analytics';

import Loader from '@/components/loader.vue';
import GlobalComponents from '@/components/global-components.js';

import SecurityPlugin from '@agrial/vue-plugin-security';
import Frontproperties, { Properties } from '@agrial/front-properties';
import VuePluginCookieConsent from '@agrial/vue-plugin-cookie-consent';
import '@agrial/vue-plugin-security/dist/index.css';

import { Fvm } from 'form-validation-manager';
import Fragment from 'vue-fragment';
import VuetifyDialog from 'vuetify-dialog';
import 'vuetify-dialog/dist/vuetify-dialog.css';
import VueApexCharts from 'vue-apexcharts';
import VueCookies from 'vue-cookies';
import { RouteName } from './router/routes';

declare global {
  interface Window {
    PROPERTIES: Properties;
  }
}

Frontproperties.loadProperties(['/application.properties', '/configuration/application.properties']).then(
  (properties) => {
    window.PROPERTIES = properties;

    Vue.config.productionTip = false;

    Vue.use(Analytics);
    Vue.use(VuePluginCookieConsent, { googleAnalyticsId: window.PROPERTIES.get('google.analytics.id'), forceDefaultNotice: true });
    Vue.use(Fvm);
    Vue.use(Fragment.Plugin);

    Vue.use(VueCookies);

    Vue.use(GlobalComponents);

    Vue.use(SecurityPlugin, {
      router,
      store
    });

    Vue.use(Utils);
    Vue.use(AxiosConfig);

    Vue.use(VueApexCharts);
    Vue.component('apexchart', VueApexCharts);

    Vue.use(VuetifyDialog, {
      context: { vuetify },
      confirm: {
        actions: {
          false: {
            text: 'Retour',
            flat: false,
            outlined: true
          },
          true: {
            text: 'Continuer',
            flat: false
          }
        },
        icon: false,
        width: 500
      },
      warning: {
        actions: {
          false: {
            text: 'Fermer',
            flat: false,
            outlined: true
          }
        },
        icon: false,
        width: 500
      },
      error: {
        actions: {
          false: {
            text: 'Fermer',
            flat: false,
            outlined: true
          }
        },
        icon: false,
        width: 500
      },
      prompt: {
        actions: {
          false: {
            text: 'Retour',
            flat: false,
            outlined: true
          },
          true: {
            text: 'valider',
            flat: false
          }
        },
        icon: false,
        width: 500
      }
    });

    Vue.component('Loader', Loader);

    const vue = new Vue({
      router,
      store,
      vuetify,
      render: (h: any) => h(App)
    } as any).$mount('#app');
  }
);

export default {};
